// extracted by mini-css-extract-plugin
export default {"dotWrapper":"status-cell_dotWrapper__e1X8Z"};